import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stepper,
  Step,
  Paper,
  StepLabel,
  CircularProgress,
  Backdrop,
  Radio, RadioGroup, FormControlLabel, Checkbox
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import db from '../../services/db';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import { useNotification } from '../../contexts/NotificationContext';
import AutocompleteWithClear from '../../components/AutocompleteWithClear';
import { syncDataFromDB } from '../../services/sync/completeDataSync';
import { Network } from '@capacitor/network'; // Importa Capacitor Network
import { useAuth } from '../../contexts/AuthContext';
import { format } from 'date-fns';
import axios from '../../services/axios';
import { useThemeConfig } from '../../contexts/ThemeContext';
import { v4 as uuidv4 } from 'uuid';

const applyMask = (value, mask) => {
  if (!value) return '';

  const onlyNumbers = value.replace(/\D/g, '');
  let masked = '';
  let index = 0;

  for (let i = 0; i < mask.length; i++) {
    if (index >= onlyNumbers.length) break;

    if (mask[i] === '9') {
      masked += onlyNumbers[index++];
    } else {
      masked += mask[i];
    }
  }

  return masked;
};

const removeMask = (value) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};


function ClientesEdit({ mode = 'edit' }) {
  const { themeSettings } = useThemeConfig();


  const isViewMode = mode === 'view'; // Define se está no modo consulta
  const isEditMode = mode === 'edit'; // Define se está no modo edição 
  const { logout, user, setUser } = useAuth();
  const { showNotification } = useNotification();

  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [cliente, setCliente] = useState({
    idCliente: null,
    nome: '',
    email: '',
    cep: '',
    telefone: '',
    endereco: '',
    bairro: '',
    cidade: '',
    estado: '',
    numero: '',
    status: 'offline',
    tipo: 'Físico',
    cpfCnpj: '',
    nomeFantasia: '',
    razaoSocial: '',
    inscricaoEstadual: '',
    campoVazio: '',
    valorLimiteCredito: 0.0,
    rea: '',
    suframa: '',
    inclusao: '1',
    complemento: '',
    tipoRamoAtividade: '',
    emailTwo: '',
    contribuinteIcms: false,
    idRamoAtividade: '',
    siglaEstado: '',
    celular: '',
    statusSic: true
  });

  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [ramosAtividade, setRamosAtividade] = useState([]);
  const steps = ['Dados Pessoais', 'Endereço', 'Confirmação'];
  const [isOnline, setIsOnline] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const cpfCnpjInput = useRef(null);
  const telefoneInput = useRef(null);
  const celularInput = useRef(null);
  const cepInput = useRef(null);
  // Função para verificar conectividade
  const checkNetworkStatus = async () => {
    const status = await Network.getStatus();
    setIsOnline(status.connected);
  };


  useEffect(() => {
    const initializeNetworkListener = async () => {
      await checkNetworkStatus(); // Verifica o status inicial da rede

      const handler = await Network.addListener('networkStatusChange', (status) => {
        setIsOnline(status.connected); // Atualiza o estado sempre que houver mudanças
      });

      return () => {
        // Remove o listener de forma segura
        if (handler.remove) {
          handler.remove();
        }
      };
    };

    const cleanup = initializeNetworkListener();

    return () => {
      // Aguarda o cleanup do listener
      cleanup.then((removeListener) => {
        if (removeListener && typeof removeListener === 'function') {
          removeListener();
        }
      });
    };
  }, []);


  // Carregar cliente e estados ao carregar o componente
  useEffect(() => {

    const fetchData = async () => {

      const ramosdata = await db.ramosDeAtividade.toArray();
      setRamosAtividade(ramosdata);

      if (id) {
        const data = await db.clientes.get(Number(id));
        if (data) {
          console.log(data)
          const ramosData = await db.ramosDeAtividade.toArray(); // Carregar ramos de atividade
          setRamosAtividade(ramosData);
          console.log(ramosData)
          console.log('--->', mode, isEditMode, isViewMode)
          const ramoAtividadeSelecionado = ramosData.find(r => r.idRamoAtividade === data.idRamoAtividade);
          console.log(ramoAtividadeSelecionado)
          const cidades = await db.cidades.where('nome').equalsIgnoreCase(data.cidade).toArray();
          const cidadeData = cidades[0];

          console.log('cidade->', cidadeData)
          console.log(data.documento)
          if (data.documento == null) {
            data.documento = data.cpfCnpj
          }

          setCliente({
            ...cliente,
            idCliente: data.id || null,
            nome: data.nome || '',
            email: data.email || '',
            cep: data.cep || '',
            telefone: applyMask(data.telefone, '(99) 9999-9999') || '',
            endereco: data.endereco || '',
            bairro: data.bairro || '',
            cidade: cidadeData?.nome || '',
            estado: cidadeData?.estado || '',
            numero: data.numero || '',
            tipo: removeMask(data.documento)?.length === 11 ? 'Físico' : 'Jurídico',
            cpfCnpj: applyMask(data.documento, removeMask(data.documento)?.length === 11 ? '999.999.999-99' : '99.999.999/9999-99') || '',
            nomeFantasia: data.nomeFantasia || '',
            razaoSocial: data.razaoSocial || '',
            complemento: data.complemento || '',  // <-- Incluído aqui
            inscricaoEstadual: data.inscricaoEstadual || '',
            idRamoAtividade: ramoAtividadeSelecionado ? ramoAtividadeSelecionado.id : '',
            tipoRamoAtividade: ramoAtividadeSelecionado ? ramoAtividadeSelecionado.descricao : '',
            contribuinteIcms: data.contribuinteIcms || false,
            status: data.status || 'true',
            sincronismo: 'false',
            celular: applyMask(data.celular, '(99) 99999-9999') || '',
            statusSic: data.statusSic || true,
            siglaEstado: cidadeData.sigla,

          });
          console.log('d')
          console.log(cliente)
        }
      }
    };

    fetchData();
  }, [id]);





  const normalizeString = (str) => {
    if (!str) return '';
    return str
      .normalize('NFD') // Remove acentuação
      .replace(/[\u0300-\u036f]/g, '') // Remove marcas de diacríticos
      .toLowerCase(); // Converte para minúsculas
  };

  const handleBuscarCEP = async () => {
    if (!cliente.cep) return;

    const formattedCep = cliente.cep.replace(/\D/g, ''); // Remove caracteres não numéricos
    console.log(`Buscando CEP: ${formattedCep}`);

    try {
      if (isOnline) {
        // Busca online (ViaCEP)
        const viaCepResponse = await fetch(`https://viacep.com.br/ws/${formattedCep}/json/`);
        if (viaCepResponse.ok) {
          const viaCepData = await viaCepResponse.json();

          if (!viaCepData.erro) {
            // Busca a cidade e estado no IndexedDB usando o nome e UF
            const cidadeCSV = await db.cidadesCSV
              .filter((c) => normalizeString(c.nome) === normalizeString(viaCepData.localidade))
              .first();

            var cidade1 = null;
            var cidadeData = null;
            try {
              cidade1 = await db.cidades.where('nome').equalsIgnoreCase(cidadeCSV.nome).toArray();
              cidadeData = cidade1[0];
            } catch {

            }
            if (cidadeData == null) {
              try {
                cidade1 = await db.cidades.where('nome').equalsIgnoreCase(viaCepData.localidade).toArray();
                cidadeData = cidade1[0];
              } catch {

              }
            }





            console.log('dd->', cidadeData)


            if (cidadeData) {
              setCliente((prev) => ({
                ...prev,
                cep: formattedCep,
                endereco: viaCepData.logradouro || '',
                bairro: viaCepData.bairro || '',
                cidade: cidadeData.nome,
                estado: cidadeData.estado,
                siglaEstado: cidadeData.estado || ''
              }));

              showNotification('Endereço encontrado com sucesso!', 'success');
              return;
            }
          }
        }

        showNotification('CEP encontrado, mas os dados estão incompletos.', 'warning');
      } else {



        const faixaCep = await db.cidadesCSV
          .filter(
            (faixa) =>
              parseInt(formattedCep) >= parseInt(faixa.cepInicial.trim()) &&
              parseInt(formattedCep) <= parseInt(faixa.cepFinal.trim())
          )
          .first();

        console.log('Faixa de CEP encontrada:', faixaCep.estado.sigla);

        // Busca a cidade usando a tabela 'cidades'
        const cidadeData = await db.cidades
          .where('nome')
          .equalsIgnoreCase(faixaCep.nome)
          .first();
        console.log(cidadeData)
        if (cidadeData) {
          setCliente((prev) => ({
            ...prev,
            cep: formattedCep,
            cidade: cidadeData.nome || '',
            estado: cidadeData.estado || cidadeData.sigla || '',
            siglaEstado: cidadeData.estado || ''
          }));
        } else {
          showNotification('ATENÇÃO!! \N CIDADE:' + faixaCep.nome + 'NÃO ESTA CADASTRADA NA BASE LOCAL SOLICITE O CADASTRO', 'success');
        }
        console.log(cidadeData)
        /*   
          setCliente((prev) => ({
            ...prev,
            cep: formattedCep,
            cidade: faixaCep.nome,
            estado: faixaCep.estado.sigla,
          }));*/

        showNotification('Endereço encontrado no banco local!', 'success');
        return;





      }
    } catch (error) {
      console.error('Erro ao buscar o CEP:', error);
      showNotification('Erro ao buscar o CEP.', 'error');
    }
  };


  const handleSave = async () => {
    if (isSaving) return; // Impede execução duplicada
    setIsSaving(true);
    try {
      // Validações básicas
      if (!cliente.nome) {
        showNotification('O campo Nome é obrigatório.');
        return;
      }
      if (
        cliente.email.toLowerCase() !== 'naotem@hotmail.com' &&
        (!cliente.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cliente.email))
      ) {
        showNotification('Informe um Email válido ou digite "não tem".', 'error');
        return;
      }

      if (!removeMask(cliente.celular) || removeMask(cliente.celular).length < 9) {
        showNotification('Informe um número de telefone válido com pelo menos 9 dígitos.');
        return;
      }
      if (cliente.tipo === 'Físico' && (!removeMask(cliente.cpfCnpj) || removeMask(cliente.cpfCnpj).length !== 11)) {
        showNotification('Informe um CPF válido com 11 dígitos.');
        return;
      }
      if (cliente.tipo === 'Jurídico' && (!removeMask(cliente.cpfCnpj) || removeMask(cliente.cpfCnpj).length !== 14)) {
        showNotification('Informe um CNPJ válido com 14 dígitos.');
        return;
      }
      if (!cliente.cep || cliente.cep.length !== 8) {
        showNotification('Informe um CEP válido com 8 dígitos.');
        return;
      }
      if (!cliente.endereco) {
        showNotification('O campo Endereço é obrigatório.');
        return;
      }
      if (!cliente.bairro) {
        showNotification('O campo Bairro é obrigatório.');
        return;
      }
      if (!cliente.numero) {
        showNotification('O campo Número é obrigatório.');
        return;
      }
      if (!cliente.cidade) {
        showNotification('Selecione uma Cidade.');
        return;
      }
      if (!cliente.estado) {
        showNotification('Selecione um Estado.');
        return;
      }
      console.log(cliente);
      const shortUuid = uuidv4().replaceAll('-', '');
  
      // Checa se o cliente já existe no IndexedDB
      const existingCliente = cliente.idCliente ? await db.clientes.get(Number(id)) : null;
      console.log("rask")
      const ramoAtividadeSelecionado = ramosAtividade.find(r => r.id === cliente.idRamoAtividade);
      if (isOnline) {
        // Atualiza ou adiciona no IndexedDB
        if (id) {
          console.log('Atualizando cliente com ID:', cliente.idCliente);
          await db.clientes.update(Number(id), { ...cliente, status: true, sincronismo: 'false', cpfCnpj: removeMask(cliente.cpfCnpj), idRamoAtividade: ramoAtividadeSelecionado.idRamoAtividade, tipoRamoAtividade: ramoAtividadeSelecionado.descricao ,cidade:cliente.cidade,estado:cliente.estado});
        } else {

          await db.clientes.add({ ...cliente, status: true, sincronismo: 'false', cpfCnpj: removeMask(cliente.cpfCnpj), idRamoAtividade: ramoAtividadeSelecionado.idRamoAtividade, tipoRamoAtividade: ramoAtividadeSelecionado.descricao,uuidMobile: shortUuid,cidade:cliente.cidade,estado:cliente.estado  });
          console.log('crian cliente com ID:', cliente.idCliente);
        }


        // Chama a sincronização quando online
        console.log('Chamando syncDataFromDB...');
        const storedUser = await db.currentUser.get('currentUser');
        await syncDataFromDB(storedUser);






      } else {
        // Está offline
        if (existingCliente) {
          // Atualiza o cliente no IndexedDB
          console.log('Atualizando cliente com ID:', cliente.idCliente);
          await db.clientes.update(Number(id), { ...cliente, status: true, sincronismo: 'false', documento: removeMask(cliente.cpfCnpj), idRamoAtividade: ramoAtividadeSelecionado.idRamoAtividade, tipoRamoAtividade: ramoAtividadeSelecionado.descricao ,cidade:cliente.cidade,estado:cliente.estado});
          showNotification('Cliente atualizado no banco local. Sincronize quando estiver online.', 'warning');
        } else {
          // Adiciona o cliente no IndexedDB
          console.log('Atualizando cliente com ID:', cliente.idCliente);
          await db.clientes.add({ ...cliente, status: true, sincronismo: 'false', documento: removeMask(cliente.cpfCnpj), idRamoAtividade: ramoAtividadeSelecionado.idRamoAtividade, tipoRamoAtividade: ramoAtividadeSelecionado.descricao ,uuidMobile: shortUuid,cidade:cliente.cidade,estado:cliente.estado});
          showNotification('Cliente salvo no banco local. Sincronize quando estiver online.', 'warning');
        }
      }

      // Redireciona para a lista de clientes
      navigate(-1)
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      showNotification('Erro ao salvar cliente.', 'error');
    } finally {
      setIsSaving(false); // Desativa o estado de carregamento
    }
  };


  const handleNext = () => {
    if (activeStep === 0) {
      // Validação da primeira etapa
      if (!cliente.nome) {
        showNotification('O campo Nome é obrigatório.', 'error');
        return;
      }
      if (
        cliente.email.toLowerCase() !== 'naotem@hotmail.com' &&
        (!cliente.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cliente.email))
      ) {
        showNotification('Informe um Email válido ou digite "não tem".', 'error');
        return;
      }

      if (!removeMask(cliente.celular) || removeMask(cliente.celular).length < 9) {
        showNotification('Informe um número de telefone válido com pelo menos 9 dígitos.');
        return;
      }
      if (cliente.tipo === 'Físico' && (!removeMask(cliente.cpfCnpj) || removeMask(cliente.cpfCnpj).length !== 11)) {
        showNotification('Informe um CPF válido com 11 dígitos.');
        return;
      }
      if (cliente.tipo === 'Físico' && !validateCPF(removeMask(cliente.cpfCnpj))) {
        showNotification('CPF inválido!', 'error');
        setCliente({ ...cliente, cpfCnpj: '' });
        return;
      }
      if (cliente.tipo === 'Jurídico' && (!removeMask(cliente.cpfCnpj) || removeMask(cliente.cpfCnpj).length !== 14)) {
        showNotification('Informe um CNPJ válido com 14 dígitos.');
        return;
      }



      console.log('tipo')
      if (cliente.tipo === 'Jurídico') {

        if (!validateCNPJ(removeMask(cliente.cpfCnpj))) {
          showNotification('CNPJ inválido!', 'error');
          setCliente({ ...cliente, cpfCnpj: '' });
          return;
        }
        if (!removeMask(cliente.cpfCnpj) || removeMask(cliente.cpfCnpj).length !== 14) {
          showNotification('Informe um CNPJ válido com 14 dígitos.', 'error');
          return;
        }
        if (!cliente.nome) {
          showNotification('Informe o Nome Fantasia para clientes jurídicos.', 'error');
          return;
        }
        if (!cliente.nomeFantasia) {
          showNotification('Informe a Razão Social para clientes jurídicos.', 'error');
          return;
        }
      }
      if (!cliente.idRamoAtividade) {
        showNotification('Selecione um Ramo de Atividade.', 'error');
        return;
      }
    }

    if (activeStep === 1) {
      // Validação da segunda etapa
      if (!cliente.cep || cliente.cep.length !== 8) {
        showNotification('Informe um CEP válido com 8 dígitos.', 'error');
        return;
      }
      if (!cliente.endereco) {
        showNotification('O campo Endereço é obrigatório.', 'error');
        return;
      }
      if (!cliente.bairro) {
        showNotification('O campo Bairro é obrigatório.', 'error');
        return;
      }
      if (!cliente.numero) {
        showNotification('O campo Número é obrigatório.', 'error');
        return;
      }
      if (!cliente.estado) {
        showNotification('Selecione um Estado.', 'error');
        return;
      }
      if (!cliente.cidade) {
        showNotification('Selecione uma Cidade.', 'error');
        return;
      }
    }





    // Se todas as validações passarem, avança para o próximo passo
    setActiveStep((prevStep) => prevStep + 1);
  };




  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1); // Volta para a lista de clientes no primeiro step
    } else {
      setActiveStep((prevStep) => prevStep - 1); // Volta ao passo anterior
    }
  };

  const handleBackList = () => {
    if (activeStep === steps.length - 1) {
      navigate(-1); // Volta para a lista de clientes no primeiro step
    } else {
      setActiveStep((prevStep) => prevStep - 1); // Volta ao passo anterior
    }
  };

  const handleCepInput = (e) => {
    const rawValue = e.target.value.replace(/\D/g, ''); // Remove caracteres não numéricos
    const maskedValue = applyMask(rawValue, '99999-999'); // Aplica a máscara

    // Atualiza o estado usando setCliente
    setCliente((prev) => ({
      ...prev,
      cep: maskedValue, // Atualiza o campo CEP corretamente
    }));
  };


  const handleTipoChange = (e) => {
    setCliente({ ...cliente, tipo: e.target.value });
  };


  // Validação de CPF (cálculo do dígito verificador)
  function validateCPF(cpf) {
    const strCPF = removeMask(cpf); // deixa só números
    if (strCPF.length !== 11) return false;

    // Elimina CPFs invalidos conhecidos
    if (/^(.)\1+$/.test(strCPF)) return false; // Ex.: "00000000000" ou "11111111111"

    let sum = 0;
    let remainder;

    // Valida 1º dígito
    for (let i = 1; i <= 9; i++) {
      sum += parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(strCPF.substring(9, 10), 10)) return false;

    // Valida 2º dígito
    sum = 0;
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(strCPF.substring(i - 1, i), 10) * (12 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(strCPF.substring(10, 11), 10)) return false;

    return true;
  }

  // Validação de CNPJ (cálculo do dígito verificador)
  function validateCNPJ(cnpj) {
    const strCNPJ = removeMask(cnpj);
    if (strCNPJ.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(.)\1+$/.test(strCNPJ)) return false; // Ex.: "00000000000000"

    let length = strCNPJ.length - 2;
    let numbers = strCNPJ.substring(0, length);
    const digits = strCNPJ.substring(length);
    let sum = 0;
    let pos = length - 7;

    // Valida 1º dígito
    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i), 10) * pos--;
      if (pos < 2) pos = 9;
    }
    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0), 10)) return false;

    // Valida 2º dígito
    length++;
    numbers = strCNPJ.substring(0, length);
    sum = 0;
    pos = length - 7;
    for (let i = length; i >= 1; i--) {
      sum += parseInt(numbers.charAt(length - i), 10) * pos--;
      if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1), 10)) return false;

    return true;
  }

  // Função auxiliar para exibir mensagem informativa sobre o tipo selecionado
  const renderTipoHelperText = () => {
    return (
      <Typography
        variant="caption"
        color="textSecondary"
        align="center"
        sx={{ mt: 1 }}
      >
        {cliente.tipo === 'Físico'
          ? 'Pessoa Física selecionada. Informe o CPF corretamente.'
          : 'Pessoa Jurídica selecionada. Informe o CNPJ, Nome Fantasia e Razão Social.'}
      </Typography>
    );
  };

  const handleBuscarClientePorDocumento = async (documento) => {
    try {
      const docSemMascara = removeMask(documento);

      // Não buscar se estiver editando ou documento inválido
      if (id || !docSemMascara) return;

      const tipo = docSemMascara.length === 11 ? 'Físico' : 'Jurídico';
      const clienteExistente = await db.clientes.where('documento').equals(documento).first();

      if (clienteExistente) {

        console.log(clienteExistente)
        const ramosData = await db.ramosDeAtividade.toArray(); // Carregar ramos de atividade
        setRamosAtividade(ramosData);
        console.log(ramosData)
        console.log('--->', mode, isEditMode, isViewMode)
        const ramoAtividadeSelecionado = ramosData.find(r => r.idRamoAtividade === clienteExistente.idRamoAtividade);
        console.log(ramoAtividadeSelecionado)
        const cidades = await db.cidades.where('nome').equalsIgnoreCase(clienteExistente.cidade).toArray();
        const cidadeData = cidades[0];

        console.log('cidade->', cidadeData)
        console.log(clienteExistente.documento)
        setCliente({
          ...cliente,
          id: clienteExistente.id || null,
          idCliente: clienteExistente.idCliente || null,
          nome: clienteExistente.nome || '',
          email: clienteExistente.email || '',
          cep: clienteExistente.cep || '',
          telefone: applyMask(clienteExistente.telefone, '(99) 9999-9999') || '',
          endereco: clienteExistente.endereco || '',
          bairro: clienteExistente.bairro || '',
          cidade: cidadeData?.nome || '',
          estado: cidadeData?.estado || '',
          numero: clienteExistente.numero || '',
          tipo: removeMask(clienteExistente.documento)?.length === 11 ? 'Físico' : 'Jurídico',
          cpfCnpj: applyMask(clienteExistente.documento, removeMask(clienteExistente.documento)?.length === 11 ? '999.999.999-99' : '99.999.999/9999-99') || '',
          nomeFantasia: clienteExistente.nomeFantasia || '',
       
          complemento: clienteExistente.complemento || '',  // <-- Incluído aqui
          inscricaoEstadual: clienteExistente.inscricaoEstadual || '',
          idRamoAtividade: ramoAtividadeSelecionado ? ramoAtividadeSelecionado.id : '',
          tipoRamoAtividade: ramoAtividadeSelecionado ? ramoAtividadeSelecionado.descricao : '',
          contribuinteIcms: clienteExistente.contribuinteIcms || false,
          status: clienteExistente.status || 'true',
          sincronismo: 'false',
          celular: applyMask(clienteExistente.celular, '(99) 99999-9999') || '',
          statusSic: clienteExistente.statusSic || true,
          siglaEstado: cidadeData.estado
        });

        showNotification('Cliente encontrado! Dados carregados.', 'success');
      }
    } catch (error) {
      console.error('Erro na busca por documento:', error);
      showNotification('Erro ao buscar cliente', 'error');
    }
  };
  const setCursorPosition = (input, newValue) => {
    if (!input.value) return;

    const originalLength = input.value.length;
    const newLength = newValue.length;
    const selectionStart = input.selectionStart;

    // Calcula a nova posição do cursor
    const diff = newValue.slice(0, selectionStart).replace(/\D/g, '').length -
      input.value.slice(0, selectionStart).replace(/\D/g, '').length;

    setTimeout(() => {
      input.selectionStart = selectionStart + diff;
      input.selectionEnd = selectionStart + diff;
    }, 0);
  };


  return (
    <Box
      sx={{



        mx: 'auto',
      }}
    >
      {/* Backdrop para indicar carregamento */}
      <Backdrop
        open={isSaving}
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Container Principal */}
      <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
        <Typography variant="h4" align="center" mb={3}>
          {id ? 'Editar Cliente' : 'Adicionar Cliente'}
        </Typography>

        {/* Stepper */}
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Conteúdo de cada etapa */}
        <Box sx={{ mt: 4 }}>
          {activeStep === 0 && (
            <Grid container spacing={2}>
              {/* Coluna da Esquerda: Tipo de Cliente */}
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" gutterBottom>
                  Tipo de Cliente
                </Typography>
                <RadioGroup
                  row
                  value={cliente.tipo}
                  onChange={handleTipoChange}
                  sx={{ justifyContent: 'center', gap: 2 }}
                >
                  <FormControlLabel
                    value="Físico"
                    control={
                      <Radio
                        icon={<PersonIcon sx={{ fontSize: 40 }} />}
                        checkedIcon={
                          <PersonIcon sx={{ fontSize: 40, color: 'secundary.main' }} />
                        }
                      />
                    }
                    label="Físico"
                    sx={{ mr: 2 }}
                  />
                  <FormControlLabel
                    value="Jurídico"
                    control={
                      <Radio
                        icon={<BusinessIcon sx={{ fontSize: 40 }} />}
                        checkedIcon={
                          <BusinessIcon sx={{ fontSize: 40, color: 'secundary.main' }} />
                        }
                      />
                    }
                    label="Jurídico"
                    sx={{ ml: 2 }}
                  />

                  {renderTipoHelperText()}

                </RadioGroup>
              </Grid>

              {/* Coluna da Direita: Nome, Nome Fantasia e Razão Social */}
              <Grid item xs={12} sm={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField inputProps={{ autoComplete: 'off' }}
                      label={cliente.tipo === 'Jurídico' ? 'Nome Fantasia' : 'Nome'}
                      variant="outlined"
                      fullWidth
                      required
                      value={cliente.nome}
                      error={!cliente.nome}
                      helperText={!cliente.nome ? 'O campo ' + cliente.tipo === 'Jurídico' ? 'Nome Fantasia' : 'Nome' + ' é obrigatório.' : ''}
                      onChange={(e) =>
                        setCliente({ ...cliente, nome: e.target.value })
                      }
                    />
                  </Grid>
                  {cliente.tipo === 'Jurídico' && (
                    <>

                      <Grid item xs={12} >
                        <TextField inputProps={{ autoComplete: 'off' }}
                          label="Razão Social"
                          variant="outlined"
                          fullWidth
                          required
                          value={cliente.nomeFantasia}
                          error={!cliente.nomeFantasia}
                          helperText={
                            !cliente.nomeFantasia
                              ? 'O campo Razão Social é obrigatório.'
                              : ''
                          }
                          onChange={(e) =>
                            setCliente({ ...cliente, nomeFantasia: e.target.value })
                          }
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>

              {/* Outros campos (CPF/CNPJ, Telefone, Celular, Email, etc.) seguem abaixo */}
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label={cliente.tipo === 'Físico' ? 'CPF' : 'CNPJ'}
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.cpfCnpj || ''}
                  ref={cpfCnpjInput}
                  onChange={(e) => {
                    const input = e.target;
                    const rawValue = input.value.replace(/\D/g, '');
                    const mask = cliente.tipo === 'Físico'
                      ? '999.999.999-99'
                      : '99.999.999/9999-99';
                    const maskedValue = applyMask(rawValue, mask);

                    setCliente({ ...cliente, cpfCnpj: maskedValue });
                    setCursorPosition(cpfCnpjInput, maskedValue);
                  }}


                  onBlur={(e) => {
                    const enteredValue = e.target.value;
                    const numericValue = removeMask(enteredValue);
                    const doc = removeMask(e.target.value);
                    if (cliente.tipo === 'Físico' && validateCPF(doc)) {
                      handleBuscarClientePorDocumento(doc);
                    }
                    if (cliente.tipo === 'Jurídico' && validateCNPJ(doc)) {
                      handleBuscarClientePorDocumento(doc);
                    }

                  }}


                  error={
                    cliente.tipo === 'Físico'
                      ? removeMask(cliente.cpfCnpj).length !== 11
                      : removeMask(cliente.cpfCnpj).length !== 14
                  }
                  helperText={
                    cliente.tipo === 'Físico' &&
                      removeMask(cliente.cpfCnpj).length !== 11
                      ? 'Informe um CPF válido com 11 dígitos.'
                      : cliente.tipo === 'Jurídico' &&
                        removeMask(cliente.cpfCnpj).length !== 14
                        ? 'Informe um CNPJ válido com 14 dígitos.'
                        : ''
                  }

                />
              </Grid>

              {/* Linha: Telefone e Celular */}
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Telefone"
                  variant="outlined"
                  ref={telefoneInput}



                  onChange={(e) => {
                    const input = e.target;
                    const rawValue = input.value.replace(/\D/g, '');
                    const mask = '(99) 9999-9999'
                    const maskedValue = applyMask(rawValue, mask);

                    setCliente({ ...cliente, telefone: maskedValue });
                    setCursorPosition(telefoneInput, maskedValue);
                  }}


                  fullWidth
                  required
                  value={cliente.telefone || ''}
                  onBlur={(e) => {
                    const maskedValue = applyMask(
                      e.target.value,
                      '(99)9999-9999'
                    );
                    setCliente({ ...cliente, telefone: maskedValue });
                  }}
                  error={!cliente.telefone || cliente.telefone.length < 9}
                  helperText={
                    !cliente.telefone || cliente.telefone.length < 9
                      ? 'Informe um número de telefone válido com pelo menos 9 dígitos.'
                      : ''
                  }

                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Celular"
                  variant="outlined"
                  fullWidth
                  ref={celularInput}
                  onChange={(e) => {
                    const input = e.target;
                    const rawValue = input.value.replace(/\D/g, '');
                    const mask = '(99) 99999-9999'
                    const maskedValue = applyMask(rawValue, mask);

                    setCliente({ ...cliente, celular: maskedValue });
                    setCursorPosition(celularInput, maskedValue);
                  }}
                  required
                  value={cliente.celular || ''}
                  onBlur={(e) => {
                    const maskedValue = applyMask(
                      e.target.value,
                      '(99)99999-9999'
                    );
                    setCliente({ ...cliente, celular: maskedValue });
                  }}
                  error={!cliente.celular || cliente.celular.length < 10}
                  helperText={
                    !cliente.celular || cliente.celular.length < 10
                      ? 'Informe um número de celular válido com pelo menos 10 dígitos.'
                      : ''
                  }

                />
              </Grid>

              {/* Linha: Email com Checkbox */}
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center">
                  <TextField inputProps={{ autoComplete: 'off' }}
                    label="Email"
                    variant="outlined"
                    fullWidth
                    required
                    value={cliente.email}
                    error={
                      cliente.email &&
                      cliente.email.toLowerCase() !== 'naotem@hotmail.com' &&
                      (!cliente.email ||
                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cliente.email))
                    }
                    helperText={cliente.email &&
                      cliente.email.toLowerCase() !== 'naotem@hotmail.com' &&
                      (!cliente.email ||
                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cliente.email))
                      ? 'Informe um Email válido ou digite "naotem@hotmail.com".'
                      : ''
                    }
                    onChange={(e) => {
                      const value = e.target.value.toLowerCase();
                      setCliente({ ...cliente, email: value });
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={cliente.email.toLowerCase() == 'naotem@hotmail.com' || false}
                        onChange={(e) =>
                          setCliente((prev) => ({
                            ...cliente,
                            email: 'naotem@hotmail.com',
                          }))
                        }
                      />
                    }
                    label="Não tem"
                    sx={{ ml: 2 }}
                  />
                </Box>
              </Grid>

              {/* Linha: Ramo de Atividade */}
              <Grid item xs={12} sm={6}>
                <AutocompleteWithClear
                  label="Ramo de Atividade"
                  options={ramosAtividade}
                  displayField="descricao"
                  getOptionLabel={(option) => `${option.descricao}`}
                  value={
                    cliente.idRamoAtividade
                      ? ramosAtividade.find((r) => r.id === cliente.idRamoAtividade)
                      : null
                  }
                  onChange={(option) =>
                    setCliente((prev) => ({
                      ...prev,
                      idRamoAtividade: option ? option.id : null,
                      tipoRamoAtividade: option ? option.descricao : '',
                    }))
                  }
                  onClear={() =>
                    setCliente((prev) => ({
                      ...prev,
                      idRamoAtividade: null,
                      tipoRamoAtividade: '',
                    }))
                  }
                  required
                />
              </Grid>
            </Grid>
          )}

          {activeStep === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="CEP"
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.cep}
                  error={!cliente.cep || cliente.cep.length !== 8}
                  helperText={
                    !cliente.cep || cliente.cep.length !== 8
                      ? 'Informe um CEP válido com 8 dígitos.'
                      : ''
                  }
                  ref={cepInput}
                  onChange={(e) => {
                    const input = e.target;
                    const rawValue = input.value.replace(/\D/g, '');
                    const mask = '99999-999';
                    const maskedValue = applyMask(rawValue, mask);

                    setCliente({ ...cliente, cep: maskedValue });
                    setCursorPosition(cepInput, maskedValue);
                  }}
                  onBlur={handleBuscarCEP}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Estado"
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.estado || ''}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Cidade"
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.cidade || ''}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Endereço"
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.endereco}
                  error={!cliente.endereco}
                  helperText={
                    !cliente.endereco ? 'O campo Endereço é obrigatório.' : ''
                  }
                  onChange={(e) =>
                    setCliente({ ...cliente, endereco: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Bairro"
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.bairro}
                  error={!cliente.bairro}
                  helperText={
                    !cliente.bairro ? 'O campo Bairro é obrigatório.' : ''
                  }
                  onChange={(e) =>
                    setCliente({ ...cliente, bairro: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Número"
                  variant="outlined"
                  fullWidth
                  required
                  value={cliente.numero}
                  error={!cliente.numero}
                  helperText={
                    !cliente.numero ? 'O campo Número é obrigatório.' : ''
                  }
                  onChange={(e) =>
                    setCliente({ ...cliente, numero: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField inputProps={{ autoComplete: 'off' }}
                  label="Complemento"
                  variant="outlined"
                  fullWidth
                  value={cliente.complemento}
                  onChange={(e) =>
                    setCliente({ ...cliente, complemento: e.target.value })
                  }
                />
              </Grid>
            </Grid>
          )}

          {activeStep === 2 && (
            <Box>
              <Typography variant="h6" align="center" gutterBottom>
                Revise os dados inseridos antes de salvar:
              </Typography>
              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,

                }}
              >
           
                <Typography variant="body1">
                  <strong>Pessoa:</strong> {cliente.tipo === 'Jurídico' ? 'Jurídico' : 'Física'}
                </Typography>
                  <Typography variant="body1">
                      <strong>Nome Fantasia:</strong> {cliente.nome}
                    </Typography>
                {cliente.tipo === 'Jurídico' && (
                  <>
                  
                    <Typography variant="body1">
                      <strong>Razão Social:</strong> {cliente.nomeFantasia}
                    </Typography>
                  </>
                )}
                <Typography variant="body1">
                  <strong>{cliente.tipo === 'Físico' ? 'CPF' : 'CNPJ'}:</strong>{' '}
                  {applyMask(
                    cliente.cpfCnpj,
                    cliente.tipo === 'Físico'
                      ? '999.999.999-99'
                      : '99.999.999/9999-99'
                  )}
                </Typography>
                <Typography variant="body1">
                  <strong>Telefone:</strong>{' '}
                  {applyMask(cliente.telefone, '(99) 9999-9999')}
                </Typography>
                <Typography variant="body1">
                  <strong>Celular:</strong>{' '}
                  {applyMask(cliente.celular, '(99) 99999-9999')}
                </Typography>
                <Typography variant="body1">
                  <strong>Email:</strong> {cliente.email}
                </Typography>
                <Typography variant="body1">
                  <strong>Ramo de Atividade:</strong>{' '}
                  {cliente.tipoRamoAtividade}
                </Typography>
                <Typography variant="body1">
                  <strong>CEP:</strong>{' '}
                  {applyMask(cliente.cep, '99999-999')}
                </Typography>
                <Typography variant="body1">
                  <strong>Estado:</strong> {cliente.estado}
                </Typography>
                <Typography variant="body1">
                  <strong>Cidade:</strong> {cliente.cidade}
                </Typography>
                <Typography variant="body1">
                  <strong>Endereço:</strong> {cliente.endereco}
                </Typography>
                <Typography variant="body1">
                  <strong>Bairro:</strong> {cliente.bairro}
                </Typography>
                <Typography variant="body1">
                  <strong>Número:</strong> {cliente.numero}
                </Typography>
                <Typography variant="body1">
                  <strong>Complemento:</strong> {cliente.complemento}
                </Typography>
              </Box>
            </Box>
          )}
        </Box>

        {/* Botões de Navegação */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mt: 4,
          }}
        >
          <Button variant="contained" onClick={handleBack}>
            {activeStep === 0 ? 'Voltar para Listagem' : 'Voltar'}
          </Button>
          {activeStep === steps.length - 1 ? (
            <>
              {!isViewMode ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  disabled={isSaving}

                >
                  Salvar
                </Button>
              ) : ('')}

              {isViewMode ? (
                <Button variant="contained" onClick={handleBackList}>
                  {'Voltar para Listagem'}
                </Button>
              ) : ('')}



            </>

          ) : (
            <Button variant="contained" color="primary" onClick={handleNext}>
              Próximo
            </Button>
          )}



        </Box>
      </Paper>
    </Box>
  );
}

export default ClientesEdit;
